import { Suspense } from 'react'

import { RouteObject } from 'react-router-dom'

import { ContentLoader } from 'shared/ui/ContentLoader'

import { SupportServiceLazy } from './routes/SupportService'

export const supportServiceRoutes: RouteObject[] = [
  {
    path: 'support',
    element: (
      <Suspense fallback={<ContentLoader />}>
        <SupportServiceLazy />
      </Suspense>
    ),
  },
]
